<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="角色名称：" prop="rolename">
                <el-input v-model="model.rolename"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: "roleEdit",
    mixins: [editutil],
    data() {
        return {
            exits_p_name:'rolename',
            exits_p_title:'角色名称',
            model: {
                rolename: '',
            },
            getObj:{
                url:'/api/admin/role/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            checkObj:{
                url:'/api/admin/role/check',
                data:{}
            },
            rules: {
                rolename: [
                    {required: true, message: '角色名称不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/role/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        },
    }
};
</script>